
import store from '@/store';
import {isIos, isAdr} from '@/constants';

const JSAPI = window.JSAPI || {};

const callbacks = {};

// 供客户端调用的api
const clientAction = {
    // 更新详情数据
    updateDetail(payload) {
        store.commit('detail:update', payload);
    },
    // 暂停音视频
    pauseMedias() {
        const audioEls = document.getElementsByTagName('audio');
        for(let i = 0; i < audioEls.length; i++) {
            if(!audioEls[i].paused) {
                audioEls[i].pause();
            }
        }
        const videoEls = document.getElementsByTagName('video');
        for(let i = 0; i < videoEls.length; i++) {
            if(!videoEls[i].paused) {
                videoEls[i].pause();
            }
        }
    },
    // 执行回调
    doBack(id, res) {
        if(callbacks[id]) {
            callbacks[id](res);
            delete callbacks[id];
        }
    }
};

// 供js端自身调用的api
const jsAction = {
    doCall(fnName, data, callback) {
        const _this = this;
        // 解决连续调用的问题
        if(this.lastCallTime && (Date.now() - this.lastCallTime) < 100) {
            setTimeout(function() {
                _this.doCall(fnName, data, callback);
            }, 100);
            return;
        }
        this.lastCallTime = Date.now();
        if(callback) {
            data.cbId = 'cb-' + this.lastCallTime;
            callbacks[data.cbId] = function(res) {
                callback(res);
            }
        }
        if(isIos) {
            // TODO
        } else if(isAdr) {
            if(data) {
                JSAPI[fnName](JSON.stringify(data));
            } else {
                JSAPI[fnName]();
            }
        } else {
            console.error('未获取platform信息，调取api失败');
        }
    }
}

export default {
    clientAction,
    jsAction
}



// WEBPACK FOOTER //
// ./src/service/js-bridge.js